const getAllTimeTrendPrompts = (checkInDataQuery) => {
    return [
        `
        You have been asked to explain the graph displaying the user's mood and stress levels over time.
        Here are the data points for mood and stress levels:

        Mood: ${JSON.stringify(checkInDataQuery.data?.mood)}
        Stress: ${JSON.stringify(checkInDataQuery.data?.stress)}

        Explain the trend you observe in both mood and stress values over time, and provide any insights you can gather from the data. 
        Please speak with a positive tone and provide encouragement to the user.
        `,
        `
        You have been asked to explain the graph displaying the user's satisfaction and tiredness levels over time.
        Here are the data points for sastisfaction and tiredness levels:

        Satisfaction: ${JSON.stringify(checkInDataQuery.data?.satisfaction)}
        Tiredness: ${JSON.stringify(checkInDataQuery.data?.tiredness)}

        Explain the trend you observe in both satisfaction and tiredness values over time, and provide any insights you can gather from the data. 
        Please speak with a positive tone and provide encouragement to the user.
        `,
    ];
};

const getPastSevenDaysTrendPrompts = (checkInDataQuery) => {
    return [
        `
        You have been asked to explain the graph displaying the user's mood and stress levels over time.
        Here are the data points for mood and stress levels for the past 7 days:

        Mood: ${JSON.stringify(checkInDataQuery.data?.mood)}
        Stress: ${JSON.stringify(checkInDataQuery.data?.stress)}

        Explain the trend you observe in both mood and stress values over time, and provide any insights you can gather from the data. 
        Please speak with a positive tone and provide encouragement to the user.
        `,
        `
        You have been asked to explain the graph displaying the user's satisfaction and tiredness levels over time.
        Here are the data points for sastisfaction and tiredness levels for the past 7 days:

        Satisfaction: ${JSON.stringify(checkInDataQuery.data?.satisfaction)}
        Tiredness: ${JSON.stringify(checkInDataQuery.data?.tiredness)}

        Explain the trend you observe in both satisfaction and tiredness values over time, and provide any insights you can gather from the data. 
        Please speak with a positive tone and provide encouragement to the user.
        `,
    ];
};

const getDistributionPrompts = (zScoresQuery) => {
    return [
        `
        You have been asked to explain the graph titled "Your Mood Z-Score Distribution," showing a normal distribution curve with a z-score marker. The z-score is calculated using the formula:

        (average mood score across all users - average mood score of this specific user) / standard deviation of mood scores across all users

        The user's z-score for mood is: ${zScoresQuery.data?.mood.toFixed(2)}
        
        Please interpret the following graph, explaining what the z-score means and how the user's mood compares to the average mood score of all users.

        Please speak with a positive tone and provide encouragement to the user.
        `,
        `
        You have been asked to explain the graph titled "Your Stress Z-Score Distribution," showing a normal distribution curve with a z-score marker. The z-score is calculated using the formula:

        (average stress score across all users - average stress score of this specific user) / standard deviation of stress scores across all users

        The user's z-score for mood is: ${zScoresQuery.data?.stress.toFixed(2)}
        
        Please interpret the following graph, explaining what the z-score means and how the user's stress compares to the average stress score of all users.

        Please speak with a positive tone and provide encouragement to the user.
        `,
        `
        You have been asked to explain the graph titled "Your Satisfaction Z-Score Distribution," showing a normal distribution curve with a z-score marker. The z-score is calculated using the formula:

        (average satisfaction score across all users - average satisfaction score of this specific user) / standard deviation of satisfaction scores across all users

        The user's z-score for mood is: ${zScoresQuery.data?.satisfaction.toFixed(2)}
        
        Please interpret the following graph, explaining what the z-score means and how the user's satisfaction compares to the average satisfaction score of all users.

        Please speak with a positive tone and provide encouragement to the user.
        `,
        `
        You have been asked to explain the graph titled "Your Tiredness Z-Score Distribution," showing a normal distribution curve with a z-score marker. The z-score is calculated using the formula:

        (average tiredness score across all users - average tiredness score of this specific user) / standard deviation of tiredness scores across all users

        The user's z-score for mood is: ${zScoresQuery.data?.tiredness.toFixed(2)}
        
        Please interpret the following graph, explaining what the z-score means and how the user's tiredness compares to the average tiredness score of all users.

        Please speak with a positive tone and provide encouragement to the user.
        `,
    ];
};

export {
    getAllTimeTrendPrompts,
    getPastSevenDaysTrendPrompts,
    getDistributionPrompts,
};
